/**
Author - Brijesh Pandey
Git - https://github.com/Brijesh-Pandey
**/

import FnoDeclarations from "./FnoDeclarations.container";

export default FnoDeclarations;
